<div class="list-page">
  <h2>Moniyritystuet</h2>

  <p style="max-width: 800px; margin-bottom: 14px">Tuet muodostuvat ja päivittyvät automaattisesti henkilötunnuksen perusteella, kun käyttäjä tunnistautuu vahvasti tai hetu poistetaan. Uudelleenmuodostus käy kaikki käyttäjät läpi ja korjaa poikkeamat; sen voi ajaa milloin vain.</p>

  <div style="display: flex; justify-content: flex-end; flex-flow: row; align-items: center; margin-bottom: 10px">
    <app-primary-button (click)="muodostaKaikki()" [disabled]="muodostusKaynnissa()" actionId="Muodosta kaikki moniyritystuet uudelleen" additionalClass="mat-elevation-z4" matIcon="sync"> Muodosta kaikki uudelleen </app-primary-button>
  </div>

  @if (commonError()) {
    <div class="error-text" style="margin-bottom: 10px">{{ commonError() }}</div>
  }

  @if (duplikaatit().length > 0) {
    <div style="margin-bottom: 10px; padding: 10px; max-width: 800px" class="mat-elevation-z2">
      <div style="font-weight: 600; margin-bottom: 6px">Samalla henkilötunnuksella on useita käyttäjiä samassa yrityksessä. Tukeen valittiin aktiivinen ja viimeksi päivitetty:</div>
      @for (duplikaatti of duplikaatit(); track duplikaatti.asiakasAvain) {
        <div style="font-size: 12px">
          Asiakas <a [routerLink]="['/asiakkaat', duplikaatti.asiakasAvain, 'kayttajat']">{{ duplikaatti.asiakasAvain }}</a
          >: {{ duplikaatti.kayttajaAvaimet.join(', ') }}
        </div>
      }
    </div>
  }

  <mat-table [dataSource]="dataSource" matSort [matSortDisableClear]="true" style="min-height: 94px">
    <ng-container matColumnDef="nimi">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Henkilö</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ row.nimi }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="hetu">
      <mat-header-cell *matHeaderCellDef>Hetu</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ annaMaskattuHetu(row) }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="yritykset">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Yritykset</mat-header-cell>
      <mat-cell *matCellDef="let row" (click)="muokkaa(row)">{{ annaYritykset(row) }}</mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>

  @if (!loading() && dataSource?.filteredData?.length == 0) {
    <div class="table-ladataan" style="position: absolute; top: 0px; width: 100%; height: 100%; display: flex; justify-items: center; align-items: center">
      <div style="width: 100%; padding-top: 40px; text-align: center">Yhtään moniyritystukea ei löytynyt.</div>
    </div>
  }
  <div lemon-loading [show]="loading()"></div>
</div>
